import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledHeaderBreadcrumbContainer = styled.div`
    ${({theme: {typography}}) => css`
        ${typography.textSm};
        width: 100%;
        overflow-x: hidden;
    `}
`

export const StyledBreadCrumbs = styled(Flexbox)`
    ${({theme: {spacing, palette}}) => css`
        color: ${palette.neutral['500']};
        overflow-x: hidden;
        height: 36px;

        & a {
            cursor: pointer;
            white-space: nowrap;
            overflow-x: hidden;
            justify-content: flex-start;
        }
        & a:first-child {
            flex-shrink: 0;
        }
        & a > span {
            text-overflow: ellipsis;
            overflow-x: hidden;
        }
        & > span {
            color: ${palette.neutral['300']};
            margin: 0 ${spacing * 2}px;
            overflow-x: hidden;
        }
    `}
`
